import { useEffect, useState, Fragment } from 'react';

import styles from './index.css';

export interface ResolvedTextProp {
    rawText?: string;
}

interface Link {
    text: string;
    url: string;
}

const ResolvedText: React.FC<ResolvedTextProp> = ({ rawText = '' }) => {
    const [elements, updateElements] = useState<string[]>([]);
    const [links, updateLinks] = useState<Link[]>([]);

    useEffect(() => {
        let newText = rawText;
        const nextLinks: Link[] = [];

        const imageElements = newText.match(/\[.*?點此大圖.*?\]\(.*?\)/g) || [];

        imageElements.forEach((element) => {
            const sourceMatch = element.match(/\[.*?點此大圖.*?\]\((.*?)\)/);
            if (sourceMatch) {
                newText = newText.replace(element, '__IMAGE__');
            }
        });

        // check for links [text](url)
        const linkElements = rawText.match(/\[.*?\)/g) || [];

        linkElements.forEach((el, index) => {
            // get only the txt
            let text = '';
            const textMatch = el.match(/\[(.*?)\]/);
            if (textMatch) {
                [, text] = textMatch;
            }

            // get only the link
            let url = '';
            const urlMatch = el.match(/\((.*?)\)/);
            if (urlMatch) {
                [, url] = urlMatch; // get only the txt
            }

            nextLinks.push({
                text,
                url,
            });
            newText = newText.replace(el, `__SPLIT_ME__[LINK_${index}]__SPLIT_ME__`);
        });

        const newElements = newText.split('__SPLIT_ME__');

        updateElements(newElements);
        updateLinks(nextLinks);
    }, [rawText]);

    return (
        <>
            {elements.map((el) => {
                const isLink = /\[LINK_.*?\]/.test(el);

                if (isLink) {
                    const linkMatch = el.match(/\[LINK_(.*?)\]/);
                    if (linkMatch) {
                        const [, linkIndexStr] = linkMatch;
                        const linkIndex = parseInt(linkIndexStr, 10);
                        return (
                            <a
                                key={linkIndexStr}
                                className={styles.link}
                                href={links[linkIndex].url}
                                target="_blank"
                                rel="noreferrer noopener"
                            >
                                {links[linkIndex].text}
                            </a>
                        );
                    }
                }

                const newText = el
                    .replace(/(\n)*__IMAGE__(\n| )*/g, '\n\n')
                    .replace(/(\n\n){3,}/g, '\n\n');

                return <Fragment key={el}>{newText}</Fragment>;
            })}
        </>
    );
};

export default ResolvedText;
